<template>
    <v-dialog
            v-model="isOpen"
            max-width="500"
    >
        <v-card>
            <v-card-title class="headline pb-10">
                Вы точно хотите удалить выбранных пользователей?
            </v-card-title>
            <v-card-text>
                Выбрано пользователей: {{checkedRows.length}}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">Закрыть</v-btn>
                <v-btn text color="primary" @click="deleteUsers()">Удалить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import OverlayLoader from '@/app/shared/components/app-loader/Loader';

    export default {
        name: 'confirmDeletionModal',
        components: {
            OverlayLoader,
        },
        props: [
            'checkedRows',
            'params'
        ],
        data() {
            return {
            };
        },
        computed: {
            isOpen: {
                get(){
                    return this.$store.getters.IS_CONFIRM_DELETION_MODAL_OPENED;
                },
                set(){
                    this.$store.dispatch('CONFIRM_DELETION_MODAL', false);
                }
            }
        },
        methods: {
            close() {
                this.$store.dispatch('CONFIRM_DELETION_MODAL', false);
            },
            deleteUsers() {
                let params = {
                    rows: this.checkedRows
                };
                this.$store.dispatch('DELETE_SELECTED_USERS', params)
                    .then(() => {
                        this.$toast.success('Пользователи удалены');
                        this.$store.dispatch('GET_USERS', this.params);
                        this.$store.dispatch('CHECKED_ROWS', []);
                        this.$store.dispatch('CONFIRM_DELETION_MODAL', false);
                    })
                    .catch(() => {
                        this.$toast.error("Ошибка сервера");
                    });
            }
        },
    };
</script>
